import React from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import anime from 'animejs';

import eventsService from '../../utils/events.service';
import { MixBlendDifference, responsiveFontSize } from 'style';

class VideoMediaComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            autoPlay: false,
            localVideo: props.video.url, //'https://www.w3schools.com/html/mov_bbb.mp4',//
            loop: props.loop,
            play: props.visible,
            visible: props.visible,
            textOverlay: props.textOverlay,
            menuOpen: false,
            unmutetext: 'Unmute',
            linkedin: false,
            currentTime: 0,
            videostate: 'preview',
            isFullscreen: false,
        };

        this.linkedInInterval = 0;

        //console.log("VideoMediaComponent ", props.visible);
        this.onVisibleChange = this.onVisibleChange.bind(this);
        this.playPause = this.playPause.bind(this);
        this.unmute = this.unmute.bind(this);
        this.fullScreen = this.fullScreen.bind(this);
        this.onMenuOpen = this.onMenuOpen.bind(this);
        this.playLinkedIn = this.playLinkedIn.bind(this);
        this.onFullScreenChange = this.onFullScreenChange.bind(this);
    }
    componentDidMount() {
        var userAgent = window.navigator.userAgent.toLowerCase();
        var isLinkedin = /linkedinapp/.test(userAgent);
        this.setState({ linkedin: isLinkedin }, this.initLinkedIn);

        /*
    Mozilla/5.0 (iPhone; CPU iPhone OS 13_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 [LinkedInApp]
    */

        this.setAttributes();

        eventsService.listenEvent('menuOpen', 'footer', this.onMenuOpen);

        this.addEventListeners();
    }
    componentWillUnmount() {
        clearTimeout(this.linkedInInterval);

        this.removeEventListeners();
    }
    addEventListeners() {
        this.media.addEventListener(
            'webkitfullscreenchange',
            this.onFullScreenChange
        );
        this.media.addEventListener(
            'mozfullscreenchange',
            this.onFullScreenChange
        );
        this.media.addEventListener(
            'fullscreenchange',
            this.onFullScreenChange
        );
    }
    removeEventListeners() {
        this.media.removeEventListener(
            'webkitfullscreenchange',
            this.onFullScreenChange
        );
        this.media.removeEventListener(
            'mozfullscreenchange',
            this.onFullScreenChange
        );
        this.media.removeEventListener(
            'fullscreenchange',
            this.onFullScreenChange
        );
    }
    setAttributes() {
        this.media.setAttribute('playsinline', '');
        this.media.setAttribute('webkit-playsinline', '');
        this.media.setAttribute('muted', 'muted');
        // this.media.removeAttribute('controls', '');
        this.media.setAttribute('autoplay', 'autoplay');
        this.media.setAttribute('loop', 'loop');
        this.media.setAttribute('autobuffer', 'autobuffer');
    }
    initLinkedIn() {
        if (this.state.linkedin === true) {
            this.media.currentTime = 1;
            this.media.pause();
        }
    }
    componentWillReceiveProps(props) {
        //console.log("props.isVisible", props.isVisible);
        this.setAttributes();

        this.onVisibleChange(props.isVisible);
    }
    onMenuOpen(menuOpen) {
        //console.log("onMenuOpen", menuOpen);
        this.setState({ menuOpen: menuOpen }, this.playPause);
    }
    onVisibleChange(visible) {
        //console.trace();
        this.setState({ visible: visible }, this.playPause);
    }
    playLinkedIn() {
        clearTimeout(this.linkedInInterval);
        if (this.state.isFullscreen === true) {
            //this.play();
        } else {
            this.media.pause();
            if (
                this.state.visible == true &&
                this.state.menuOpen == false &&
                this.media &&
                this.state.linkedin === true
            ) {
                this.media.currentTime = this.state.currentTime;
                this.media.pause();
                if (this.media.duration > this.media.currentTime + 0.1) {
                    this.setState({
                        currentTime: this.media.currentTime + 0.1,
                    });
                } else {
                    this.setState({ currentTime: 0 });
                }
                this.linkedInInterval = setTimeout(this.playLinkedIn, 100);
            }
        }
    }
    playPause() {
        //console.log("playPause", this.state.visible, this.state.menuOpen, this.state.localVideo);
        let videostate = 'paused';
        if (this.state.visible == true && this.state.menuOpen == false) {
            videostate = 'playing';
        }
        // this.setState({ videostate: videostate }, this.playLinkedIn);

        if (this.state.linkedin === false) {
            if (this.media) {
                if (
                    this.state.visible == true &&
                    this.state.menuOpen == false
                ) {
                    this.play();
                } else {
                    this.pause();
                }
            }
        } else {
            this.playLinkedIn();
        }
    }
    play() {
        // console.log('Play');
        this.media.volume = 1;
        var promise = this.media.play();
        if (promise !== undefined) {
            promise
                .then(() => {
                    // Autoplay started!
                })
                .catch(error => {
                    // Autoplay was prevented.
                    // Show a "Play" button so that user can start playback.
                });
        }
    }
    pause() {
        // console.log('Pause');
        var myObject = {
            volume: this.media.volume * 10,
        };
        anime({
            targets: myObject,
            volume: 0,
            easing: 'linear',
            round: 1,
            duration: 500,
            update: () => {
                if (this.media) {
                    this.media.volume = myObject.volume / 10;
                }
            },
            complete: () => {
                if (this.media) {
                    this.media.pause();
                }
            },
        });
    }
    unmute(e) {
        // console.log('unmute');
        this.media.muted = !this.media.muted;
        this.setState({ unmutetext: this.media.muted ? 'Unmute' : 'Mute' });
        e.stopPropagation();
    }
    updateMuteText() {
        this.setState({ unmutetext: this.media.muted ? 'Unmute' : 'Mute' });
    }
    fullScreen() {
        if (this.media.requestFullscreen) {
            this.media.requestFullscreen();
        } else if (this.media.mozRequestFullScreen) {
            this.media.mozRequestFullScreen();
        } else if (this.media.webkitEnterFullScreen) {
            this.media.webkitEnterFullScreen();
        }
        this.media.muted = false;
        clearTimeout(this.linkedInInterval);
        this.play();
        this.updateMuteText();
    }
    onFullScreenChange() {
        var isFullscreen = false;
        if (document.fullscreenElement) {
            isFullscreen = document.fullscreenElement !== null;
        }
        if (document.webkitFullscreenElement) {
            isFullscreen = document.webkitFullscreenElement !== null;
        }
        if (document.mozFullScreenElement) {
            isFullscreen = document.mozFullScreenElement !== null;
        }
        if (document.msFullscreenElement) {
            isFullscreen = document.msFullscreenElement !== null;
        }
        // console.log('isFullscreen', isFullscreen);
        if (isFullscreen === false) {
            // this.media.removeAttribute('controls');
        }
        this.setState({ isFullscreen: isFullscreen }, this.playLinkedIn);
    }
    render() {
        return (
            <VideoWrapper
                aspectRatio={this.props.aspectRatio}
                backgroundColor={this.props.backgroundColor}>
                <VideoControls>
                    {this.props.showFullscreenControl && (
                        <button
                            onClick={this.fullScreen}
                            data-cursor="focus"
                            data-cursor-persistance="500"
                            className="text2">
                            Fullscreen
                        </button>
                    )}
                    {this.props.showMuteControl && (
                        <button
                            onClick={this.unmute}
                            data-cursor="focus"
                            data-cursor-persistance="500"
                            className="text2">
                            {this.state.unmutetext}
                        </button>
                    )}
                </VideoControls>
                <video
                    ref={el => (this.media = el)}
                    css={video_css}
                    autoPlay={this.state.autoPlay}
                    onProgress={this.onProgress}
                    loop={this.state.loop}
                    onPlay={() => {
                        this.props.onLoad();
                    }}
                    muted
                    playsInline
                    controls={false}>
                    <source src={this.state.localVideo} type="video/mp4" />
                </video>
                <TextOverlay>{this.state.textOverlay}</TextOverlay>
            </VideoWrapper>
        );
    }
}

const VideoWrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${props => props.backgroundColor || 'transparent'};
    video[muted] {
    }

    video {
        display: block;
    }
`;
const video_css = css`
    width: 100%;
    max-width: 100%;
`;

const VideoControls = styled.div`
    ${MixBlendDifference};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    text-align: center;

    button{
      border: 0;
      background: none;
      padding: 1vw .65vw;
      margin: 0;
      /* ${responsiveFontSize(14, 20)} */

      color: #fff;
      min-width: 90px;
      &:focus{
        outline: none;
      }
    }
`;
const TextOverlay = styled.p`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    mix-blend-mode: difference;
    padding: 1vw 0.65vw;
`;

export default VideoMediaComponent;
